import { render } from "./Dashboard.vue?vue&type=template&id=39f99822&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=39f99822&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39f99822"

export default script